import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import Email from '@material-ui/icons/Email';
import Phone from '@material-ui/icons/Phone';
import AccountBox from '@material-ui/icons/AccountBox';
import Menu from '@material-ui/core/Menu';
import { TextInput, ChangePassword, Username } from '../../components/textInput';
import { Btn } from '../../components/global';
import { AuthForm } from '../../components/authForm';
import { USezpayAuthForm } from '../../components/authForm/USezpayAuthForm';
import { withProfile } from "../../containers/profile";
import LogoMobile from "../../logo2.svg";
import Logo from "../../MenuSifu_New-Logo.png"
import { getUrlVars } from '../../utils'

const styles = theme => ({
    textInputs: {
        marginBottom: 65,
        width: "100%"
    },
    button: {
        width: '100%',
        height: 50,
        marginBottom: 20
    },
    lastButton: {
        marginBottom: 0
    },
    navbar: {
        marginBottom: 50,
        width: 500,
        margin: 'auto'
    },
    inputFields: {
        display: 'flex',
        flexDirection: 'column'
    },
    link: {
        textAlign: "left"
    },
    adorment: {
        marginLeft: "-10px"
    },
    countryCode: {
        marginLeft: 10,
        lineHeight: "56px"
    },
    forgetPassword: {
        color: "rgba(0,0,0,0.87)",
        width: "100%",
        textAlign: "right",
        marginBottom: "100px",
        textDecoration: "none",
        display: "block"
    },
    input: {
        width: "100%",
        marginBottom: 30
    },
    textField: {
        width: "100%"
    },
    inputWithMarginBtm: {
        marginBottom: 30
    },
    verifySent: {
        height: 25,
        marginBottom: 10,
        textAlign: "left"
    }
})

export default withProfile(withStyles(styles)((props) => {
    const {
        classes,
        username,
        step,
        loading,
        setInputField,
        confirmChange,
        selectPhoneOrEmail,
        phoneOrEmail,
        messagePool,
        isUSezpay
    } = props;
    const {
        PWD_MUST, PWD_LENGTH_RULE, PWD_NUMBER_RULE,
        PWD_UPPERCASE_RULE, PWD_LOWERCASE_RULE, CONFIRM,
        VERIFICATION, PWD_FORGET_SUCCESS
    } = props.messagePool;
    const [showPassword, togglePwdDisplay] = useState(false);
    function handleClickShowPassword() {
        togglePwdDisplay(!showPassword);
    }
    const [pwdValidation, setPwdValidation] = useState("");
    function validatePassword(event) {
        const value = event.target.value;
        let len, digit, uppercase, lowercase;
        len = value.length >= 8;
        digit = /^(?=.*\d).+$/.test(value);
        uppercase = /^(?=.*[A-Z])/.test(value);
        lowercase = /^(?=.*[a-z])/.test(value);
        if (len && digit && uppercase && lowercase) {
            setPwdValidation("")
        } else {
            let message = `${PWD_MUST}: `;
            if (!len) {
                message += `${PWD_LENGTH_RULE}, `
            } 
            if (!digit || !uppercase || !lowercase) {
                message += `${digit ? "" : `${PWD_NUMBER_RULE}, `}${uppercase? "" : `${PWD_UPPERCASE_RULE}, `}${lowercase? "": PWD_LOWERCASE_RULE}`
            }
            setPwdValidation(message);
        }
    }
    // Determine branding based on isUSezpay flag
    const FormComponent = isUSezpay ? USezpayAuthForm : AuthForm;

    return (
            <FormComponent title={"FORGET PASSWORD?"} >
            <div>
            {step == 1 ?
                <div>
                    <div className={classes.textInputs}>
                        <div className={classes.inputWithMarginBtm} key={"username"} style={{width: '100%'}}>
                            <Username label={messagePool[phoneOrEmail.toUpperCase()]}
                                onChange={setInputField("username")}
                                defaultValue={username}
                                value={username}
                                onChangeType={selectPhoneOrEmail}
                                autoComplete='new-password'
                                type={phoneOrEmail}
                            />
                        </div>
                        { phoneOrEmail != "phone" ? null :
                            <div className={classes.inputWithMarginBtm} >
                                <TextInput label={VERIFICATION} onChange={setInputField("verification")}/>
                            </div>
                        }
                        <ChangePassword
                            onChangePwd={setInputField("newPassword")}
                            onChangeConfirmPwd={setInputField("confirmPassword")}
                            onKeyDown={(e) => {
                                if (e.keyCode == 13) {
                                    confirmChange();
                                }
                            }}
                        />
                    </div>
                    <Btn variant="contained"
                        color="primary"
                        className={classes.button}
                        style={isUSezpay ? { backgroundColor: '#d9b97f', color: '#fff' } : {}}
                        onClick={confirmChange}
                    >
                        {loading? <CircularProgress color="secondary" /> : CONFIRM}
                    </Btn>
                </div> :
                PWD_FORGET_SUCCESS
            }
        </div>
    </FormComponent>
    );
}))